// Ebbrest: подарки к коврику (решение 13.10.2026, Ilia; products/bed-cooling-system/store.md, «Подарки собраны»).
// Подключается с defer из snippets/eb-gifts.liquid, настройки там же: window.ebGifts
//   { hero: id товара-коврика, count: штук в корзине на момент загрузки страницы,
//     variants: [{ id, t: уровень, o: [значения опций] }], gifts: [{ p: id товара, t: с какого уровня, v: id варианта }] }.
//
// Что делает:
// 1. Держит в корзине подарки по уровню коврика. После любого изменения корзины (штатное событие Shopify
//    shopify:cart:lines-update, его шлют форма товара Horizon, корзина темы, eb-cart.js и eb-complete.js) читает
//    /cart.js и сверяет: уровень это наибольший уровень среди ковриков в корзине, положены подарки с уровнем не выше.
//    Недостающие кладёт (POST /cart/add.js, свойство строки _gift: 1), лишние убирает (POST /cart/update.js):
//    коврик убрали, уровень стал ниже, у подарка количество больше одного, два подарка одного товара.
//    Два коврика дают один набор. Бесплатными подарки делают скидки магазина (scripts/ebbrest-gifts.py), не скрипт.
// 2. Помнит, что положил сам (localStorage, ключ ebGifts, привязка к токену корзины). Подарок, который он клал
//    и которого в корзине больше нет, значит убран покупателем: в этой корзине он обратно не кладётся.
//    Коврик убрали совсем: память сбрасывается, следующий коврик снова приходит с полным набором.
// 3. Переключатель размера у подарка в корзине (snippets/eb-gift-size.liquid): кладёт другой вариант с пометкой
//    _gift и убирает прежнюю строку.
// 3a. Тот же вариант куплен ещё и отдельно: при равной цене Shopify делает бесплатной строку, которая стоит в корзине
//    выше (добавлена позже), и это может оказаться купленная строка, а подарок с _gift остаётся платным. Сумма та же,
//    но пометка Gift и поле количества оказываются не у тех строк. Скрипт перекладывает такие подарки заново
//    (убрать и положить): они встают выше купленной строки и снова бесплатны. Не больше трёх раз за страницу.
// 3b. Пока идёт сверка, оформление придержано: нажатие на Check out запоминается и срабатывает после сверки,
//    кнопки быстрой оплаты не нажимаются (html[data-eb-gifts-busy], стиль в snippets/eb-cart-gifts.liquid).
//    Иначе покупатель успевает уйти в оформление с ковриком без подарков (между ними около секунды).
//    Страховка: через 6 секунд придержка снимается в любом случае. Запрос не прошёл: один повтор через 1,5 с.
// 4. На странице коврика ставит уровень блоку подарков (blocks/eb-gifts.liquid, атрибут data-eb-tier) по карточкам
//    версии и комплекта и прячет в блоке «Complete your night» (sections/eb-complete.liquid) допы, которые при
//    выбранной версии идут подарком.
//
// Чего не делает: fetch темы не перехватывает и разметку корзины руками не переписывает. Корзину перерисовывает
// Horizon: скрипт шлёт её штатное событие CartLinesUpdateEvent с обещанием, как assets/eb-cart.js.
// Корзину сторонним строкам не трогает: правит только строки со свойством _gift.
// Без JS подарки в корзину не попадают (ограничение, записано в store.md).
// Ключей из .env не берёт. Диагностика: ?eb_debug=1 в адресе пишет шаги в консоль.
(function () {
  'use strict';
  if (window.__ebGifts) return;
  window.__ebGifts = true;

  var cfg = window.ebGifts;
  if (!cfg || !cfg.hero || !cfg.gifts || !cfg.gifts.length) return;

  var DEBUG = /[?&]eb_debug=1/.test(location.search);
  var EVENT = 'shopify:cart:lines-update';
  var STORE_KEY = 'ebGifts';
  var memory = null;

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ['[eb-gifts]'].concat([].slice.call(arguments)));
  }

  var tierByVariant = {};
  cfg.variants.forEach(function (v) { tierByVariant[v.id] = v.t; });
  var giftByProduct = {};
  cfg.gifts.forEach(function (g) { giftByProduct[g.p] = g; });

  function routes() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return { add: root + 'cart/add.js', update: root + 'cart/update.js', cart: root + 'cart.js', page: root + 'cart' };
  }

  function sectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }

  function request(url, body) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        log(body ? 'POST' : 'GET', url, response.status);
        if (!response.ok || (data && data.status && data.message)) {
          throw new Error((data && (data.description || data.message)) || 'cart request failed');
        }
        return data;
      });
    });
  }

  function withSections(body) {
    var ids = sectionIds();
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = location.pathname;
    }
    return body;
  }

  /* Память: что положили сами (added) и от чего покупатель отказался (off), оба списка это id товаров. */
  function loadState(token) {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { s = memory; }
    if (!s && memory) s = memory;
    if (s && s.token === token && s.added && s.off) return s;
    return { token: token, added: [], off: [] };
  }

  function saveState(s) {
    memory = s;
    try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function isGift(item) {
    return !!(item.properties && item.properties._gift);
  }

  /* Сколько с строки сняла скидка подарков (название начинается с «Free gift», scripts/ebbrest-gifts.py). */
  function giftOff(item) {
    var sum = 0;
    (item.line_level_discount_allocations || []).forEach(function (d) {
      var title = (d.discount_application && d.discount_application.title) || '';
      if (title.indexOf('Free gift') === 0) sum += Number(d.amount) || 0;
    });
    return sum;
  }

  var swapsLeft = 3;

  /* Что нужно сделать с корзиной. Ничего не шлёт. */
  function plan(cart, state) {
    var tier = 0;
    var updates = {};
    var changed = false;
    var adds = [];
    var present = {};

    cart.items.forEach(function (item) {
      if (item.product_id === cfg.hero) tier = Math.max(tier, tierByVariant[item.variant_id] || 1);
    });

    /* 3a: самая верхняя купленная строка, которую скидка подарков сделала бесплатной, по цене штуки */
    var boughtFreeAt = {};
    var swap = false;
    cart.items.forEach(function (item, index) {
      if (isGift(item) || !giftOff(item)) return;
      if (boughtFreeAt[item.original_price] === undefined) boughtFreeAt[item.original_price] = index;
    });

    cart.items.forEach(function (item, index) {
      if (!isGift(item)) return;
      var gift = giftByProduct[item.product_id];
      if (!gift || gift.t > tier || present[item.product_id]) {
        updates[item.key] = 0;
        changed = true;
        return;
      }
      present[item.product_id] = true;
      if (item.quantity > 1) {
        updates[item.key] = 1;
        changed = true;
      }
      if (item.final_line_price > 0 && boughtFreeAt[item.original_price] !== undefined && boughtFreeAt[item.original_price] < index) swap = true;
    });

    if (swap && swapsLeft > 0) {
      swapsLeft -= 1;
      cart.items.forEach(function (item, index) {
        if (!isGift(item) || updates[item.key] === 0) return;
        var top = boughtFreeAt[item.original_price];
        if (top === undefined || top > index) return;
        updates[item.key] = 0;
        changed = true;
        adds.push({ id: item.variant_id, quantity: 1, properties: { _gift: '1' } });
      });
    }

    var next = { token: state.token, added: [], off: state.off.slice() };
    if (tier === 0) {
      next.off = [];
    } else {
      state.added.forEach(function (id) {
        var gift = giftByProduct[id];
        if (gift && gift.t <= tier && !present[id] && next.off.indexOf(id) < 0) next.off.push(id);
      });
      cfg.gifts.forEach(function (gift) {
        if (gift.t > tier) return;
        if (present[gift.p]) { next.added.push(gift.p); return; }
        if (next.off.indexOf(gift.p) >= 0) return;
        adds.push({ id: gift.v, quantity: 1, properties: { _gift: '1' } });
        next.added.push(gift.p);
      });
    }
    return { tier: tier, updates: changed ? updates : null, adds: adds, state: next };
  }

  /* Модуль стандартных событий Shopify из importmap темы. Грузится вставкой <script type="module">: import()
     в классическом ассете Shopify при сжатии переписывает (см. assets/eb-cart.js). */
  var eventsModule = null;
  function loadEvents() {
    if (eventsModule) return eventsModule;
    eventsModule = new Promise(function (resolve) {
      var done = false;
      function finish(mod) {
        if (done) return;
        done = true;
        resolve(mod && mod.CartLinesUpdateEvent ? mod : null);
      }
      try {
        window.__ebGiftsEvents = finish;
        var tag = document.createElement('script');
        tag.type = 'module';
        tag.textContent = "import * as m from '@shopify/events'; window.__ebGiftsEvents && window.__ebGiftsEvents(m);";
        tag.onerror = function () { finish(null); };
        document.head.appendChild(tag);
        setTimeout(function () { finish(null); }, 4000);
      } catch (e) {
        finish(null);
      }
    });
    return eventsModule;
  }

  var mine = typeof WeakSet === 'function' ? new WeakSet() : null;

  /* Свои изменения корзины: событие темы до запросов, обещание исполняется итогом. work() возвращает
     { cart, sections }. Без модуля событий на странице корзины перезагружаем её, шторка обновится при переходе. */
  function mutate(work) {
    return loadEvents().then(function (mod) {
      var deferred = null;
      if (mod) {
        deferred = mod.CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(function () {});
        var event = new mod.CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise: deferred.promise });
        if (mine) mine.add(event);
        document.dispatchEvent(event);
      }
      return work().then(function (result) {
        if (deferred) {
          deferred.resolve({
            cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(result.cart),
            detail: {
              sections: result.sections || undefined,
              items: result.cart.items,
              itemCount: result.cart.item_count,
              source: 'eb-gifts',
              didError: false
            }
          });
        } else if (document.querySelector('cart-items-component:not([data-drawer])')) {
          location.reload();
        }
        return result;
      }, function (error) {
        if (deferred) deferred.reject(error);
        throw error;
      });
    });
  }

  function apply(todo) {
    return mutate(function () {
      var r = routes();
      var chain = Promise.resolve(null);
      var sections = null;
      var cart = null;
      if (todo.updates) {
        chain = chain.then(function () {
          return request(r.update, todo.adds.length ? { updates: todo.updates } : withSections({ updates: todo.updates }));
        }).then(function (data) {
          cart = data;
          sections = data.sections || null;
        });
      }
      if (todo.adds.length) {
        chain = chain.then(function () {
          return request(r.add, withSections({ items: todo.adds }));
        }).then(function (data) {
          sections = data.sections || null;
          return request(r.cart);
        }).then(function (data) { cart = data; });
      }
      return chain.then(function () { return { cart: cart, sections: sections }; });
    });
  }

  var running = false;
  var again = false;
  var timer = 0;
  var fails = 0;
  var pendingSize = 0;

  /* 3b. Придержка оформления на время сверки. */
  var CHECKOUT = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"]';
  var busy = false;
  var busyTimer = 0;
  var held = null;

  function setBusy(on) {
    clearTimeout(busyTimer);
    if (on) {
      busy = true;
      document.documentElement.setAttribute('data-eb-gifts-busy', '');
      busyTimer = setTimeout(function () { setBusy(false); }, 6000);
      return;
    }
    if (!busy) return;
    busy = false;
    document.documentElement.removeAttribute('data-eb-gifts-busy');
    var target = held;
    held = null;
    if (!target) return;
    /* корзину за это время могли перерисовать: тогда кнопка уже другая */
    if (!target.isConnected) target = document.querySelector('cart-drawer-component dialog[open] button[name="checkout"]') || document.querySelector('button[name="checkout"]');
    if (target) target.click();
    else location.assign(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout');
  }

  window.addEventListener('click', function (event) {
    if (!busy || !event.target || !event.target.closest) return;
    var target = event.target.closest(CHECKOUT);
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    held = target;
    log('checkout held');
  }, true);

  function reconcile() {
    if (running) { again = true; return; }
    running = true;
    var failed = false;
    request(routes().cart).then(function (cart) {
      var state = loadState(cart.token);
      var todo = plan(cart, state);
      log('tier', todo.tier, 'adds', todo.adds.length, 'updates', todo.updates, 'off', todo.state.off);
      if (!todo.updates && !todo.adds.length) {
        saveState(todo.state);
        return null;
      }
      return apply(todo).then(function () { saveState(todo.state); });
    }).then(function () {
      fails = 0;
    }, function (error) {
      failed = true;
      log('failed', String(error));
    }).then(function () {
      running = false;
      if (again) { again = false; schedule(); return; }
      /* запрос не прошёл: один повтор, оформление пока придержано (страховка снимет через 6 с) */
      if (failed && fails < 1) {
        fails += 1;
        clearTimeout(timer);
        timer = setTimeout(reconcile, 1500);
        return;
      }
      setBusy(false);
      if (pendingSize) {
        var button = document.querySelector('[data-eb-gift-size][data-variant="' + pendingSize + '"]');
        pendingSize = 0;
        if (button) button.click();
      }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 60);
  }

  document.addEventListener(EVENT, function (event) {
    if (mine && mine.has(event)) return;
    if (event.detail && event.detail.source === 'eb-gifts') return;
    var promise = event.promise;
    setBusy(true);
    if (promise && promise.then) promise.then(schedule, function () { setBusy(false); });
    else setTimeout(schedule, 400);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) schedule();
  });

  if (cfg.count > 0) {
    if (window.requestIdleCallback) requestIdleCallback(schedule, { timeout: 2000 });
    else setTimeout(schedule, 600);
  }

  /* 3. Размер подарка в корзине. Сначала кладём новый вариант, потом убираем прежнюю строку: если первый запрос
        не прошёл, подарок остаётся как был. */
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-eb-gift-size]') : null;
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-pressed') === 'true') return;
    var key = button.getAttribute('data-key');
    var variant = Number(button.getAttribute('data-variant'));
    var group = button.closest('.eb-gift-size');
    if (!key || !variant) return;
    if (group) group.setAttribute('aria-busy', 'true');
    /* идёт сверка: нажатие не теряем, повторим после неё (корзину к тому времени могут перерисовать) */
    if (running) { pendingSize = variant; return; }
    running = true;
    setBusy(true);
    var r = routes();
    mutate(function () {
      return request(r.add, { items: [{ id: variant, quantity: 1, properties: { _gift: '1' } }] }).then(function () {
        var updates = {};
        updates[key] = 0;
        return request(r.update, withSections({ updates: updates }));
      }).then(function (cart) {
        return { cart: cart, sections: cart.sections || null };
      });
    }).catch(function (error) {
      log('size failed', String(error));
      if (group && group.isConnected) group.removeAttribute('aria-busy');
    }).then(function () {
      running = false;
      schedule();
    });
  });

  /* 4. Страница коврика: уровень по карточкам версии и комплекта (blocks/eb-size-cards.liquid). */
  function checked(cards, name) {
    var input = cards.querySelector('input[data-eb-card="' + name + '"]:checked');
    return input ? input.value : null;
  }

  function pageTier(section) {
    var cards = section.querySelector('[data-eb-size-cards]');
    if (!cards || cards.hasAttribute('data-eb-off')) return 0;
    var chosen = [];
    var setup = checked(cards, 'setup');
    if (setup) chosen.push(setup);
    if (cards.getAttribute('data-eb-pending') !== 'true') {
      var model = checked(cards, 'model');
      if (model) chosen.push(model);
    }
    var tier = 0;
    cfg.variants.forEach(function (v) {
      for (var i = 0; i < chosen.length; i++) if (v.o.indexOf(chosen[i]) < 0) return;
      if (!tier || v.t < tier) tier = v.t;
    });
    return tier;
  }

  function paint(section) {
    var block = section.querySelector('[data-eb-gifts]');
    var tier = pageTier(section);
    if (block && tier && block.getAttribute('data-eb-tier') !== String(tier)) block.setAttribute('data-eb-tier', String(tier));
    if (!tier && block) tier = Number(block.getAttribute('data-eb-tier')) || 0;
    if (!tier) return;

    /* «Complete your night»: доп, который при этой версии идёт подарком, платным не предлагаем */
    [].forEach.call(document.querySelectorAll('[data-eb-complete]'), function (root) {
      if (String(root.getAttribute('data-product-id')) !== String(cfg.hero)) return;
      var rows = root.querySelectorAll('[data-eb-product]');
      var visible = 0;
      [].forEach.call(rows, function (row) {
        var gift = giftByProduct[Number(row.getAttribute('data-eb-product'))];
        var hide = !!gift && gift.t <= tier;
        if (row.hidden !== hide) {
          row.hidden = hide;
          var input = row.querySelector('[data-eb-complete-item]');
          if (hide && input && input.checked) {
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (!hide) visible += 1;
      });
      if (rows.length && root.hidden !== (visible === 0)) root.hidden = visible === 0;
    });
  }

  function watch(block) {
    var section = block.closest('.shopify-section');
    if (!section || section.__ebGiftsWatched) return;
    section.__ebGiftsWatched = true;
    var queued = false;
    function run() {
      queued = false;
      paint(section);
    }
    /* Тема перерисовывает секцию товара после каждой смены варианта и возвращает блоку уровень с сервера. */
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(run);
    }).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-eb-pending', 'checked'] });
    section.addEventListener('change', function () { paint(section); });
    paint(section);
  }

  function initPage(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-eb-size-cards]'), watch);
  }

  document.addEventListener('shopify:section:load', function (event) { initPage(event.target); });
  window.addEventListener('pageshow', function () { initPage(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initPage(); });
  else initPage();
})();
